/* eslint eqeqeq: "off" */
/*
 * Employee Login
 */
import React, { useState } from "react";
import { Button, Input, ConfigProvider, Image, Form, Row, Col } from "antd";
import PropTypes from "prop-types";
//components
import Logo from "../../assets/images/logo (1).png";
import "./auth.css";
import {TinyColor} from "@ctrl/tinycolor";
import { isEmpty } from "lodash";
import { useHistory } from "react-router";
import api from "../../helpers";
import { toast, ToastContainer } from "react-toastify";
import useMedia from "use-media-antd-query";
import { MetaTags } from "react-meta-tags";
import { setAuthToken } from "../../helpers/index";

const EmployeeLogin = (props) => {
  const media = useMedia();

  const [loader, setLoader] = useState(false);

  //Initial state values end/

  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [employeeValidations, setEmployeeValidations] = useState(false);
  const [isLoginDisabled, setIsLoginDisabled] = useState(false);

  const history = useHistory();

  //login submit
  // const employeeLogin = () => {
  //   if (!isEmpty(userName) && !isEmpty(password)) {
  //     setIsLoginDisabled(true);
  //     setTimeout(() => {
  //       setIsLoginDisabled(false)
  //     }, 4000);
  //     const user = {
  //       userName: userName,
  //       password: password,
  //       isAdmin: true,
  //     };
  //     api
  //       .post("/auth/internal/login", user)
  //       .then((res) => {
  //         toast.success("User Logged in successfully");
  //         localStorage.setItem("authToken", res.data.token);
  //         localStorage.setItem("user", res.data);
  //         localStorage.setItem("authData", JSON.stringify(res.data));
  //         setAuthToken(res.data.token);
  //         setLoader(true);
  //         setEmployeeValidations(false);

  //         setTimeout(() => {
  //           setLoader(false);
  //           if (res.data.success == true || res.data.success == "login successful") {
  //             history.push("/employee-dashboard");
  //           }
  //         }, 2000);
  //         return res.data;
  //       })
  //       .catch((error) => {
  //         const errorMsg =
  //           (error && error.message) ||
  //           (error &&
  //             error.response &&
  //             error.response.data &&
  //             error.response.data.error) ||
  //           (error &&
  //             error.response &&
  //             error.response.data &&
  //             error.response.data.message)||
  //             (error &&
  //               error.response &&
  //               error.response.data &&
  //               error.response.data.msg);
  //         toast.error(errorMsg);

  //         setLoader(true);
  //         setTimeout(() => {
  //           setLoader(false);
  //         }, 2000);
  //         Promise.reject(error);
  //       });

  //   } else {
  //     setEmployeeValidations(true);
  //   }
  // };

  // login submit
  const employeeLogin = () => {
    if (!isEmpty(userName) && !isEmpty(password)) {
      setIsLoginDisabled(true);
      setTimeout(() => {
        setIsLoginDisabled(false);
      }, 4000);

      const user = {
        userName: userName,
        password: password,
        isAdmin: true,
      };

      api
        .post("/auth/internal/login", user)
        .then((res) => {
          toast.success("User Logged in successfully");

          localStorage.setItem("authToken", res.data.token);
          localStorage.setItem("user", JSON.stringify(res.data));
          localStorage.setItem("authData", JSON.stringify(res.data));
          localStorage.setItem("userType", res.data.userType)
          setAuthToken(res.data.token);
          setLoader(true);
          setEmployeeValidations(false);

          setTimeout(() => {
            setLoader(false);
            if (
              res.data.success === true ||
              res.data.success === "login successful"
            ) {
              history.push("/employee-dashboard");
            }
          }, 500);

          return res.data;
        })
        .catch((error) => {


          const errorMsg =
            error?.message |
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.response?.data?.msg;

          toast.error(errorMsg || "Login failed. Please try again.");

          setLoader(true);
          setTimeout(() => {
            setLoader(false);
          }, 2000);

          return Promise.reject(error);
        });
    } else {
      setEmployeeValidations(true);
    }
  };

  //button styles

  const getHoverColors = (colors) =>
    colors.map((color) => new TinyColor(color).lighten(5).toString());
  const getActiveColors = (colors) =>
    colors.map((color) => new TinyColor(color).darken(5).toString());

  const colors1 = ["#6253E1", "#04BEFE"];

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Employee Login | Mequals</title>
        </MetaTags>
      </div>
      <Row className="employee-login-main-card">
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            media === "xs"
              ? "employee-login-image flex justify-center"
              : "employee-login-image lg:pr-0 lg:pl-0 md:pr-0 md:pl-0 sm:pr-4 sm:pl-4 pl-4 pr-4 flex md:justify-end lg:justify-end justify-center"
          }
        >
          <Col
            md={12}
            lg={8}
            sm={20}
            xs={20}
            className="employee-login-form-main pt-3"
          >
            <div
              className={
                media === "xs"
                  ? "employee-login-form-grid pt-[50px] pr-[25px] pl-[25px] rounded-lg "
                  : "employee-login-form-grid pt-[50px] pr-[50px] pl-[50px] sm:rounded-lg rounded-lg md:rounded-tr-none md:rounded-br-none md:rounded-tl-lg md:rounded-bl-lg"
              }
            >
              <div className="mb-2 text-start">
                <Image src={Logo} preview={false} width={150} />
              </div>
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="mb-2 text-[black] text-start"
              >
                <h1 className="flex text-[#768ea7]">
                  Welcome to{" "}
                  <p className="pl-1 font-semibold text-[#768ea7]">Mequals</p>
                </h1>
              </div>
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="mb-2 text-[black] text-start"
              >
                <h1
                  className={
                    media === "xs"
                      ? "flex text-[black] text-[16px] font-semibold"
                      : "flex text-[black] text-[20px] font-semibold"
                  }
                >
                  Login with your username and password
                </h1>
              </div>

              {/* <Typography className="mt-1 auth-login-label mb-1 text-[red] text-[13px] text-center">
                {error && error ? error : ""}
              </Typography> */}
              <Form.Item className="mt-2 mb-1">
                <Input
                  name="username"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder="Enter your username"
                  className="auth-login-label py-3"
                />
                <p className="text-[red] text-[12px] mt-2 mb-2 text-start">
                  {employeeValidations &&
                    isEmpty(userName) &&
                    "Username is required"}
                </p>
              </Form.Item>

              <Form.Item className="mt-2 mb-1">
                <Input.Password
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="auth-login-label py-3 large-eye-icon"
                />
                <p className="text-[red] text-[12px] mt-2 mb-2 text-start">
                  {employeeValidations &&
                    isEmpty(password) &&
                    "Password is required"}
                </p>
              </Form.Item>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      colorPrimary: `linear-gradient(116deg, ${colors1.join(
                        ", "
                      )})`,
                      colorPrimaryHover: `linear-gradient(116deg, ${getHoverColors(
                        colors1
                      ).join(", ")})`,
                      colorPrimaryActive: `linear-gradient(116deg, ${getActiveColors(
                        colors1
                      ).join(", ")})`,
                      lineWidth: 0,
                    },
                  },
                }}
              >
                <Button
                  className="auth-login-label text-[13px] mt-[15px] p-4 w-[100%]"
                  type="primary"
                  style={{
                    fontFamily: "Poppins",
                  }}
                  // disabled={signInButtonDisabled}
                  disabled={isLoginDisabled}
                  onClick={employeeLogin}
                >
                  {loader ? "Loading..." : "Login"}
                </Button>
              </ConfigProvider>
            </div>
          </Col>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

EmployeeLogin.propTypes = {
  onSignin: PropTypes.any,
};

export default EmployeeLogin;
